"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ErrorOutlined = _interopRequireDefault(require("@material-ui/icons/ErrorOutlined"));

var _Gate = _interopRequireDefault(require("../Gate"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

/* eslint-disable prettier/prettier */
var styles = function styles(theme) {
  return {
    message: {
      border: "1px solid",
      borderRadius: 4,
      padding: theme.spacing(1),
      boxShadow: theme.shadows[2]
    },
    error: {
      display: 'flex',
      backgroundColor: theme.palette.error.dark,
      borderColor: theme.palette.error.dark
    },
    errorIcon: {
      color: theme.palette.primary.contrastText,
      marginRight: theme.spacing(1)
    },
    warn: {
      backgroundColor: theme.palette.warning.light,
      borderColor: theme.palette.warning.main,
      color: theme.palette.warning.text
    },
    success: {
      backgroundColor: theme.palette.primary.light,
      borderColor: theme.palette.primary.main
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
/**
 * Please opt to use Alert instead. This should be deprecated.
 */

var FormMessage = function FormMessage(_ref) {
  var variant = _ref.variant,
      children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.message, classes[variant])
  }, /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: variant === 'error'
  }, /*#__PURE__*/_react["default"].createElement(_ErrorOutlined["default"], {
    className: classes.errorIcon,
    fontSize: "small"
  })), children);
};

FormMessage.propTypes = {
  /** The variant of the component */
  variant: _propTypes["default"].oneOf(['error', 'warn', 'success']).isRequired,

  /** The content of the component. */
  children: _propTypes["default"].node.isRequired
};
var _default = FormMessage;
exports["default"] = _default;